import { render, staticRenderFns } from "./TvtimeImporter.vue?vue&type=template&id=0a79e010&scoped=true"
import script from "./TvtimeImporter.vue?vue&type=script&setup=true&lang=ts"
export * from "./TvtimeImporter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TvtimeImporter.vue?vue&type=style&index=0&id=0a79e010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a79e010",
  null
  
)

export default component.exports